// Recovered from the preserved MetaCard production build.
// Behavior is retained; local names and TypeScript types were lost during minification.
import * as jsxRuntime from "react/jsx-runtime";
import { IconSparkles } from "./components/icons.jsx";
import { IconCards } from "./components/icons.jsx";
import { Tx } from "./assets.jsx";
import { Cx } from "./assets.jsx";
import { Mx } from "./assets.jsx";
import { IconDiamond } from "./components/icons.jsx";
import { Km } from "./assets.jsx";
import { $m } from "./assets.jsx";
import { IconCoin } from "./components/icons.jsx";
import { Nx } from "./assets.jsx";
import { IconBox } from "./components/icons.jsx";
import { jn } from "./assets.jsx";
export function metaPassRewardFromText(u) {
  if (!u || u === "❌") return {
    icon: jsxRuntime.jsx(IconSparkles, {}),
    title: "Нет награды"
  };
  if (u === "MetaPass") return {
    icon: jsxRuntime.jsx(IconCards, {}),
    title: "Карта MetaPass",
    image: Tx
  };
  if (u === "Theme") return {
    icon: jsxRuntime.jsx(IconSparkles, {}),
    title: "Тема профиля",
    image: Cx
  };
  if (u === "AnimatedEmoji") return {
    icon: jsxRuntime.jsx(IconSparkles, {}),
    title: "Анимированный эмодзи",
    image: Mx
  };
  const [o, m] = u.split(" ");
  return m === "💎" ? {
    icon: jsxRuntime.jsx(IconDiamond, {}),
    title: "Кристаллы",
    amount: o,
    image: Km
  } : m === "🎴" ? {
    icon: jsxRuntime.jsx(IconCards, {}),
    title: "Крутки",
    amount: o,
    image: $m
  } : m === "🍡" ? {
    icon: jsxRuntime.jsx(IconCoin, {}),
    title: "Фрагменты",
    amount: o,
    image: Nx
  } : {
    icon: jsxRuntime.jsx(IconBox, {}),
    title: "LIMITED кейс",
    amount: o,
    image: jn
  };
}
